import React from "react";
import { observer } from "mobx-react";
import { Button, Checkbox, TextField } from "@material-ui/core";
import { get, jsonParser, multipartForm, post, put } from "../../utils/Client";
import CheckBox from "../../components/CheckBox";
import ImageUpload from "../../components/ImageUpload";


class PurchaseCertificates extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      config: {
        ticketX: "",
        ticketY: "",
        skusX: "",
        skusY: "",
        quantityX: "",
        quantityY: "",
        customerNameX: "",
        customerNameY: "",
        vendorNameX: "",
        vendorNameY: "",
        fontSize: "",
        fontColor: "",
      },
      file: null,
      loading: false,
      submitting: false,
      error: "",
      pdfData: null,
    }
  }

  componentDidMount() {
    this.setState({ loading: true }, this.getConfig);
  }

  getConfig = async () => {
    try{
      const res = await get(`/purchase-certificates/current`).then(jsonParser);
      this.setState({ error: "", loading: false, config: res });
    } catch(e){
      console.log(e.message ?? e);
      this.setState({ error: e.message ?? "Erro ao carregar dados do servidor. Tente novamente mais tarde", loading: false });
    }
  }

  getPdf = async () => {
    try{
      const { file, config } = this.state;

      const formData = new FormData();
      formData.append("data", new Blob([JSON.stringify(config)], { type: "application/json" }));
      if(file){
        formData.append("file", file, file.name);
      }

      const res = await multipartForm(`/purchase-certificates/test`, { body: formData });

      if(res.status !== 200){
        const message = await res.text();
        throw new Error(message);
      }
      const pdfBlob = await res.blob();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      if (this.state.pdfData) {
        URL.revokeObjectURL(this.state.pdfData);
      }

      this.setState({ error: "", submitting: false, pdfData: pdfUrl });
    } catch(e){
      console.log(e.message ?? e);
      this.setState({ error: e.message ?? "Erro ao carregar dados do servidor. Tente novamente mais tarde", submitting: false });
    }
  }

  submit = async () => {
    try{
      const { file, config } = this.state;

      const formData = new FormData();
      formData.append("data", new Blob([JSON.stringify(config)], { type: "application/json" }));
      if(file){
        formData.append("file", file, file.name);
      }

      await multipartForm(`/purchase-certificates/update/${config.id}`, { body: formData }).then(jsonParser);
      this.setState({ submitting: false, error: "", loading: true }, this.getConfig);
    } catch(e){
      console.log(e.message ?? e);
      this.setState({ error: e.message ?? "Erro ao salvar configuração", submitting: false });
    }
  }

  handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    const name = file?.name;

    // limpa o input pra permitir reenvio do mesmo arquivo
    e.target.value = "";

    if (!file) return;

    if (file.size > 20000000) {
      this.setState({ error: "O arquivo não pode ser maior que 20MB" });
      return;
    }

    this.setState({ file: file });
  };

  render() {
    const { submitting, loading, error, config, pdfData } = this.state;

    return (
      <div className="holder" style={styles.container}>
        <h4>
          Envie uma notificação para as vendedoras
        </h4>

        <div style={styles.body}>
          <div style={styles.form}>
            <TextField
              value={config.ticketX}
              label="Posição X do ticket (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, ticketX: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />
            <TextField
              value={config.ticketY}
              label="Posição Y do ticket (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, ticketY: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />

            <TextField
              value={config.skusX}
              label="Posição X dos skus (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, skusX: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />
            <TextField
              value={config.skusY}
              label="Posição Y dos skus (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, skusY: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />

            <TextField
              value={config.quantityX}
              label="Posição X da quantidade (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, quantityX: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />
            <TextField
              value={config.quantityY}
              label="Posição Y da quantidade (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, quantityY: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />

            <TextField
              value={config.customerNameX}
              label="Posição X do nome do(a) cliente (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, customerNameX: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />
            <TextField
              value={config.customerNameY}
              label="Posição Y do nome do(a) cliente (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, customerNameY: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />

            <TextField
              value={config.vendorNameX}
              label="Posição X do nome do(a) vendedor(a) (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, vendorNameX: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />
            <TextField
              value={config.vendorNameY}
              label="Posição Y do nome do(a) vendedor(a) (milímetros)"
              placeholder="100.5"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, vendorNameY: e.target.value.replace(new RegExp("[^0-9.-]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />

            <TextField
              value={config.fontSize}
              label="Tamanho da fonte"
              placeholder="12"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, fontSize: e.target.value.replace(new RegExp("[^0-9]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />
            <TextField
              value={config.fontColor}
              label="Cor da fonte"
              placeholder="#000000"
              variant="outlined"
              onChange={(e) => this.setState({ config: { ...config, fontColor: e.target.value.replace(new RegExp("[^0-9#A-Fa-f]", "g"), "") }})}
              fullWidth
              disabled={loading || submitting}
              style={{ marginBottom: 10 }}
            />
            
            <Button variant="outlined" component="label" disabled={loading || submitting}>
              {`Selecionar template PDF ${this.state.file ? "(" + this.state.file.name + ")" : config.fileName ? "(" + config.fileName + ")" : ""}`}
              <input 
                type="file"
                hidden
                accept=".pdf"
                onChange={this.handleFileChange}
              />
            </Button>

            <div style={{ fontSize: 16, textAlign: "left", color: "#000000" }}>
              <ul>
                <li>Posições são medidas em milímetros, a partir do canto inferior esquerdo</li>
                <li>Para esconder uma informação, coloque coordenadas negativas</li>
                <li>A cor deve ser no formato #FFFFFF</li>
              </ul>
            </div>
          </div>


          { (!!error) &&
            <div style={{ color: "#FF0000", fontSize: 12, width: "100%", textAlign: "left", marginBottom: 20 }}>
              {error}
            </div>
          }
          <div style={{ display: "flex", flexDirection: "row", gap: 20, width: "100%", justifyContent: "center" }}>
            <Button 
              onClick={() => this.setState({ submitting: true, pdfData: null }, this.getPdf)}
              disabled={submitting || loading}
              size="medium"
              variant="outlined"
              color="default"
            >
              Testar
            </Button>
            <Button 
              onClick={() => this.setState({ submitting: true }, this.submit)}
              disabled={submitting || loading}
              size="medium"
              variant="outlined"
              color="default"
            >
              Salvar
            </Button>
          </div>

        </div>
        { !!pdfData &&
          <div style={{ marginTop: 20, width: "100%" }}>
            <iframe
              src={pdfData}
              style={{ width: "210mm", height: "297mm", border: 0 }}
            />
          </div>
        }
      </div>
    );
  }
}

export default observer(PurchaseCertificates);

const styles = {
  container               : {
    paddingLeft               : 10,
    paddingTop                : 10,
    width                     : "80%",
  },
  subHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
  },
  panelsStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  checkBox: {
    marginRight: 5,
    padding: 3,
    alignSelf: "flex-start",
  },
  body: { 
    paddingLeft: 20, 
    paddingRight: 30, 
  },
  form: {
    display: "grid",
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: 20,
    marginBottom: 20,
  },
};